import {
  IonIcon,
  IonItem,
  IonModal,
  IonButton,
  IonText,
} from "@ionic/react";
import { flowerOutline } from "ionicons/icons";
import React, { useState } from "react";
import "./MultiIris.css";

function MultiIris() {
  const [showModal, setShowModal] = useState(false);

  return (
    <div>
      <IonItem className="ion-hide-sm-up">
        <IonIcon icon={flowerOutline} slot="start" className="ion-icon" />

        <IonModal
          isOpen={showModal}
          className="ion-modal-popup"
          backdropDismiss="false"
        >
          <IonText className="ion-justify-content-center ion-align-items-center ion-margin">
            <br />
            <b>Multi-Dimensional Analysis of Iris with PCA and t-SNE</b>
            <p>
              For working with multi-dimensional user data, I used
              dimension-reduction techniques like PCA (principal component
              analysis) and t-SNE (t-distributed stochastic neighborhood
              embedding) to better visualize the data on a two-dimensional
              plane. The original project with CharacTour involved confidential
              datasets, so I recreated this analysis using the open-source Iris
              dataset in <code>R</code>.{" "}
            </p>

            <a
              href="https://cameronlowdata.shinyapps.io/IrisDimension/"
              target="_blank"
              rel="noreferrer"
            >
              Click here to see the dashboard.
            </a>
            <br />
            <IonButton
              className="ion-button"
              onClick={() => setShowModal(false)}
            >
              Close
            </IonButton>

            <br />
          </IonText>
        </IonModal>

        <IonButton className="ion-button" onClick={() => setShowModal(true)}>
          Show
        </IonButton>
      </IonItem>
    </div>
  );
}

export default MultiIris;
